import { useEffect, useState, useCallback } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { EditorialMarquee } from "./components/EditorialMarquee";
import { WhatWeDo } from "./components/WhatWeDo";
import { AIWorkforce } from "./components/AIWorkforce";
import { EnterpriseAI } from "./components/EnterpriseAI";
import { EnterpriseExperience } from "./components/EnterpriseExperience";
import { AutomationFlow } from "./components/AutomationFlow";
import { CloudEngineering } from "./components/CloudEngineering";
import { SelectedWork } from "./components/SelectedWork";
import { Products } from "./components/Products";
import { Industries } from "./components/Industries";
import { HowWeWork } from "./components/HowWeWork";
import { WhyJiyonox } from "./components/WhyJiyonox";
import { AboutText } from "./components/AboutText";
import { Philosophy } from "./components/Philosophy";
import { Faq } from "./components/Faq";
import { Insights } from "./components/Insights";
import { FinalCTA } from "./components/FinalCTA";
import { ContactModal } from "./components/ContactModal";
import Admin from "./pages/Admin";
import ServicePage from "./pages/ServicePage";

const Home = () => {
  const [contactOpen, setContactOpen] = useState(false);
  const openContact = useCallback(() => setContactOpen(true), []);

  return (
    <div className="bg-jx-paper">
      <Navbar onContact={openContact} />
      <main>
        <Hero onContact={openContact} />
        <EditorialMarquee />
        <WhatWeDo />
        <AIWorkforce />
        <EnterpriseAI />
        <EnterpriseExperience />
        <AutomationFlow />
        <CloudEngineering />
        <SelectedWork onContact={openContact} />
        <Products />
        <Industries />
        <HowWeWork />
        <WhyJiyonox />
        <AboutText />
        <Philosophy />
        <Insights />
        <Faq />
      </main>
      <FinalCTA onContact={openContact} />
      <ContactModal open={contactOpen} onClose={() => setContactOpen(false)} />
    </div>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster position="bottom-right" richColors />
    </BrowserRouter>
  );
}

export default App;
